import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Btn, Chip } from "@/components/rp";
import { Section } from "@/components/commesse";

export const PhaseMapEditor = ({ url, perOrder }) => {
  const [d, setD] = useState(null);
  const [m, setM] = useState({});
  const [dirty, setDirty] = useState(false);
  const apply = (data) => { setD(data); setM(data.map); setDirty(false); };
  useEffect(() => { api.get(url).then((r) => apply(r.data)).catch(() => {}); }, [url]);
  if (!d) return null;
  const toggle = (ph, k) => {
    const cur = m[ph] || [];
    setM({ ...m, [ph]: cur.includes(k) ? cur.filter((x) => x !== k) : [...cur, k] });
    setDirty(true);
  };
  const save = async (map) => {
    try { apply((await api.put(url, { map })).data); toast.success(map === null ? "Torna a valere la regola generale" : "Abbinamenti salvati"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Section label={perOrder ? "Fattura a ogni fase (questo cantiere)" : "Fattura a ogni fase (regola generale)"} testid="phase-map"
      action={<div className="flex flex-wrap gap-2">
        {perOrder && d.custom && <Btn variant="outline" className="h-9" onClick={() => save(null)} data-testid="phase-map-reset">Usa regola generale</Btn>}
        <Btn className="h-9" disabled={!dirty} onClick={() => save(m)} data-testid="phase-map-save"><Save className="h-4 w-4" /> Salva</Btn>
      </div>}>
      <div className="rounded-2xl bg-[#E6DDCE]/50 p-4 text-sm mb-4 space-y-1" data-testid="phase-map-help">
        <p className="font-medium">A cosa serve: decide quando l'app ti ricorda di emettere ogni fattura.</p>
        <p className="text-[#4A4A4A]">Ogni riga è una fase del cantiere; i pulsanti neri sono le fatture da preparare quando il cantiere arriva a quella fase. Esempio: con «Inizio lavori → Sal 1», appena segni l'inizio lavori la fattura del SAL 1 compare nello Scadenzario e l'amministrazione riceve un'email. Le fasi già passate non generano fatture.</p>
        <p className="text-[#757575]">{perOrder ? (d.custom ? "Questo cantiere usa abbinamenti personalizzati." : "Ora vale la regola generale: cambia qui solo se questo cantiere va fatturato diversamente.") : "Vale per tutti i cantieri, salvo quelli con abbinamenti personalizzati."}</p>
      </div>
      <div className="space-y-2">
        {d.phases.map(([ph, label]) => (
          <div key={ph} className="flex flex-wrap items-center gap-2 py-2 border-b border-[#EBEBEB] last:border-0" data-testid={`phase-map-row-${ph}`}>
            <span className={`text-sm w-full sm:w-64 shrink-0 ${perOrder && d.done.includes(ph) ? "text-[#757575]" : "font-medium"}`}>{label}{perOrder && d.done.includes(ph) && " · già raggiunta"}</span>
            {d.invoices.map(([k, l]) => <Chip key={k} active={(m[ph] || []).includes(k)} onClick={() => toggle(ph, k)} data-testid={`phase-map-${ph}-${k}`}>{l}</Chip>)}
          </div>
        ))}
      </div>
    </Section>
  );
};
